// extracted by mini-css-extract-plugin
export default {"container":"OX-z","title":"PX-z","link":"QX-z"};